import { AA as AAShieldStarter } from "@utils/adobeAnalyticsSS";
import { DSAcquisitionDataLayerObject, DSDataLayer, DSFormDataLayerObject, DSUserDataLayerObject } from "../DataLayer/Datalayer.model";
declare const window: any;

export const trackOnLoad = (props?:{formUpdated?: Partial<DSFormDataLayerObject>,acquisitionUpdated?: Partial<DSAcquisitionDataLayerObject>, userUpdated?: Partial<DSUserDataLayerObject>, errorPage?:{errorCode?:string, errorMsg?:string}}) => {
    const AA = AAShieldStarter.getInstance();
    const { form, acquisition, user, page } = AA.digitalData as DSDataLayer;

    form.name = "";
    form.error.fieldLabels = [];
    form.error.messages = [];
    form.error.numErrors = "0";

    if(props?.acquisitionUpdated){
      dataObjectUpdater(acquisition, props.acquisitionUpdated)
    }
    if(props?.formUpdated){
      dataObjectUpdater(form, props.formUpdated)
    }
    if(props?.userUpdated){
      dataObjectUpdater(user, props.userUpdated)
    }
      page.errorCode = props?.errorPage?.errorCode || ""
      page.errorMessage = props?.errorPage?.errorMsg || ""
  
    AA.trackPageLoad({ form, acquisition, page });
  };

  // props?:{form?:string, error?:{fieldLabels?:[], messages?:[], numErrors?: "0"}

  export const trackOnFormStartOrSuccess= (formName?:string, isSuccess?:boolean)=>{
    const AA = AAShieldStarter.getInstance();
    const { form, page } = AA.digitalData as DSDataLayer;

    if(formName === form.name && !isSuccess){
      return;
    }
    if(formName !== form.name && isSuccess){
      return;
    }

    // form.name = props?.form || "";
    // form.error.fieldLabels = props?.error?.fieldLabels ||  [];
    // form.error.messages =  props?.error?.messages || [];
    // form.error.numErrors = props?.error?.numErrors || "0";   
    
    form.name = formName|| "";
    form.error.fieldLabels =   [];
    form.error.messages =  [];
    form.error.numErrors ="0";   
    page.errorCode =  ""
    page.errorMessage =  ""
    
    if(isSuccess){
      AA.trackFormCompleted({form}, "");
    }else {
    AA.trackPageStart({form})}

  }

  export const updateMarketing = (isMarketingOptin: "Yes" | "No")=>{
    const AA = AAShieldStarter.getInstance();
    const { acquisition } = AA.digitalData as DSDataLayer;
    acquisition.customer.marketingOptIn = isMarketingOptin

    if (window._satellite && window.digitalData) {
      Object.assign(window.digitalData, acquisition);
      sessionStorage.setItem(
        "singlife_aa_cached",
        JSON.stringify(window.digitalData)
      );
    }

  }

  export const trackOnFormError = ({name, error}: {name:string, error:{fieldLabels: string[], messages: string[], numErrors:string}})=>{
    const AA = AAShieldStarter.getInstance();
    const { form, page } = AA.digitalData as DSDataLayer;
    form.name = name|| "";
    form.error.fieldLabels =   [];
    form.error.messages =  [];
    form.error.numErrors ="0";   
    page.errorCode =  ""
    page.errorMessage =  ""
    Object.assign(form.error, error);

    AA.trackFormCompleted({form, page}, 'error')
    
  }


  export const trackOnSuccess = (props?:{formUpdated?: Partial<DSFormDataLayerObject>,acquisitionUpdated?: Partial<DSAcquisitionDataLayerObject>, userUpdated?: Partial<DSUserDataLayerObject>}) => {
    const AA = AAShieldStarter.getInstance();
    let { form, acquisition,user } = AA.digitalData as DSDataLayer;
    form.name = "";
    form.error.fieldLabels = [];
    form.error.messages = [];
    form.error.numErrors = "0";
    
    if(props?.acquisitionUpdated){
      dataObjectUpdater(acquisition, props.acquisitionUpdated)
    }
    if(props?.formUpdated){
      dataObjectUpdater(form, props.formUpdated)
    }
    if(props?.userUpdated){
      dataObjectUpdater(user, props.userUpdated)
    }
  
    AA.trackPurchasSuccessful({ form, acquisition });
  };

// Do NOT modify function shared between DS and CCP
  export function dataObjectUpdater(originalObj: Record<string, any>,updatedObj: Record<string, any> = {}){
    if(typeof updatedObj !== "object")
      return;
    let keys = Object.keys(updatedObj)
    for(let key of keys){
      if(originalObj?.hasOwnProperty(key)){
        //@ts-ignore
        Object.assign(originalObj[key] , updatedObj[key])
      }
    }
  }